// Config loader - exports the active configuration based on build variant
import { AppConfig, AppVariant } from './types';
import { coopConfig } from './coop.config';
import { blitzConfig } from './blitz.config';
import { partyConfig } from './party.config';
import { teamConfig } from './team.config';
import { familyConfig } from './family.config';
import { newConfig } from './new.config';

// Map of all available configs
const configs: Record<AppVariant, AppConfig> = {
  coop: coopConfig,
  blitz: blitzConfig,
  party: partyConfig,
  team: teamConfig,
  family: familyConfig,
  new: newConfig,
};

// Get variant from environment variable (set at build time)
// REACT_APP_VARIANT is set in .env files or build command
const variant = (process.env.REACT_APP_VARIANT || 'coop') as AppVariant;

// Validate variant
if (!configs[variant]) {
  console.warn(`Unknown app variant: ${variant}, falling back to 'coop'`);
}

// Export active config
export const config: AppConfig = configs[variant] || configs.coop;

// Export variant for conditional logic if needed
export const appVariant: AppVariant = variant;

// Re-export types for convenience
export type { AppConfig, AppVariant, GameConfig, ThemeConfig } from './types';

// Re-export all games for backward compatibility during migration
export { ALL_GAMES, BLITZ_GAMES, COOP_GAMES, PARTY_GAMES, TEAM_GAMES, FAMILY_GAMES, NEW_GAMES } from './games';

